/* global jQuery:false */
// expand / collapse agenda rows
(function ($) {
	"use strict";

	$(".title-speaker-container").on("click", function(event){
		if ($(event.currentTarget).hasClass("expanded")) {
			$(event.currentTarget).removeClass("expanded").addClass("collapsed");
			$(event.currentTarget).parent(".description").find(".abstract").addClass("hidden");
		} else if ($(event.currentTarget).hasClass("collapsed")) {
			$(event.currentTarget).removeClass("collapsed").addClass("expanded");
			$(event.currentTarget).parent(".description").find(".abstract").removeClass("hidden");
		}
	});

}(jQuery));

// agenda tab functionality
(function ($) {
	"use strict";

	$(".tablink").on("click", function(event){
		var tabId = $(event.currentTarget).attr("data-tab-id");
		$(".tablink").removeClass("active");
		$(event.currentTarget).addClass("active");
		$(".tab-content").addClass("hidden");
		$("#"+tabId).removeClass("hidden");
	});

	// if hash value containing tab ID exists, trigger a click on the tab
	var hash = window.location.hash.replace(/#|\//gi, "");
	$('[data-tab-id="'+hash+'"]').click();

}(jQuery));
